export default __webpack_public_path__ + "static/media/burger-builder.af7dd711.png";